/**
 * Sets the image to be displayed in the gallery.
 *
 * @param {string} galleryId The id of the gallery.
 * @param {string} imgSrc The source of the image.
 */
function setSlide(galleryId, imgSrc) {
  // Hide all images and show the one that was clicked.
  $('#gallery-' + galleryId).find('.modal-body img').addClass('d-none').removeClass('d-block');
  $('#gallery-' + galleryId).find(`.modal-body img[src="${imgSrc}"]`).addClass('d-block').removeClass('d-none');

  // Hide all content and show the one that was clicked.
  $('#gallery-' + galleryId).find('.modal-body .content').addClass('d-none').removeClass('d-block');
  $('#gallery-' + galleryId).find(`.modal-body .content[data-for-src="${imgSrc}"]`).addClass('d-block').removeClass('d-none');

  // Set the current image number.
  const imageNumber = $('#gallery-' + galleryId).find(`.modal-body img[src="${imgSrc}"]`).data('image-number');
  $('#gallery-' + galleryId).find('.modal-body .current-image').text(imageNumber);

  // Set the download link.
  $('#gallery-' + galleryId).find('.modal-body a.download').attr('href', imgSrc);
}

jQuery(function () {
  $(".gallery").each(function () {
    const $gallery = $(this);
    const images = [];
    const content = [];

    // Generate a random ID for the gallery.
    const galleryId = (Math.random() + 1).toString(36).substring(7);

    const imagesCount = $gallery.find("img").length;
    let x = 1;
    $gallery.find("img").each(function () {
      const $img = $(this);
      images.push(`<img data-image-number="${x}" src="${$img.attr("src")}" class="${x === 1 ? 'd-block first' : 'd-none'} ${x === imagesCount ? 'last' : ''} h-auto mb-3 mx-auto" style="max-height: 60vh;" alt="${$img.attr('alt')}">`);
      content.push(`<div class="${x === 1 ? 'd-block first' : 'd-none'} ${x === imagesCount ? 'last' : ''} content mb-3 text-center" data-for-src="${$img.attr('src')}"><h4>${$img.attr('alt')}</h4>\n<h5 class="mb-0">${$img.data('summary')}</h5></div>`);
      $img.css('cursor', 'pointer');

      $img.on('click', function () {
        setSlide(galleryId, $img.attr('src'));

        // Show the modal.
        $('#gallery-' + galleryId).modal('show');
      });

      x += 1;
    });

    // Create the Bootstrap modal for this gallery.
    const modal = `
      <div class="modal fade" tabindex="-1" id="gallery-${galleryId}">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-body">
              <div class="actions actions-top d-flex justify-content-between align-items-center mb-3">
                <button class="btn btn-primary control prev"><i class="far fa-chevron-left"></i></button>
                <h5 class="text-muted mb-0"><span class="current-image">1</span>/${imagesCount}</h5>
                <button class="btn btn-primary control next"><i class="far fa-chevron-right"></i></button>
              </div>

              ${images.join('\n')}
              ${content.join('\n')}

              <div class="actions actions-bottom d-flex justify-content-end">
                <a class="btn btn-success me-3 download" href="#" download>Download</a>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    // Append the modal to the DOM.
    $("body").append(modal);

    // Bind the control events.
    $('#gallery-' + galleryId).find('.control').on('click', function () {
      // Get the current image.
      const $currentImage = $('#gallery-' + galleryId).find('.modal-body img.d-block');

      // Are we going forward or backwards?
      let $nextImage = null;
      if ($(this).hasClass('next')) {
        // Get the next image.
        $nextImage = $currentImage.next();
      } else {
        // Get the previous image.
        $nextImage = $currentImage.prev();
      }

      // Ensure we have a valid image.
      if ($nextImage !== null && $nextImage.length && $nextImage.is('img')) {
        // Set the image to be displayed.
        setSlide(galleryId, $nextImage.attr('src'));
      } else {
        //
      }
    });

    // Bind any "more" buttons to open the modal.
    $(this).find('.gallery-more').css('cursor', 'pointer');
    $(this).find('.gallery-more').on('click', function () {
      // Show the modal.
      $('#gallery-' + galleryId).modal('show');
    });
  });
});
